import ApiService from "@/api/api";

export default class DispendiosService {
    constructor() {
        this.resource = "/v1/projetos";
    }

    getDispendios(projectId, params = {}) {
        return ApiService.get(`${this.resource}/${projectId}/dispendios`, {
            params
        });
    }
}
